<!-- src/components/Request/DeleteRequestDialog.vue -->
<template>
    <v-dialog
      v-model="dialogModel"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 bg-error text-white">
          <v-icon left>mdi-delete-alert</v-icon>
          Confirmar Exclusão
        </v-card-title>
        
        <v-card-text class="pt-4">
          <v-alert
            type="warning"
            prominent
            class="mb-4"
          >
            Esta ação não pode ser desfeita.
          </v-alert>
          
          <p class="mb-4"><strong>Tem certeza que deseja excluir esta requisição?</strong></p>
          
          <v-card v-if="request" outlined class="mt-3 pa-4">
            <v-row dense>
              <v-col cols="4" class="font-weight-bold">Código:</v-col>
              <v-col cols="8">{{ request.code }}</v-col>
            </v-row>
            
            <v-divider class="my-2"></v-divider>
            
            <v-row dense>
              <v-col cols="4" class="font-weight-bold">Descrição:</v-col>
              <v-col cols="8">{{ request.description }}</v-col>
            </v-row>
            
            <v-divider class="my-2"></v-divider>
            
            <v-row dense>
              <v-col cols="4" class="font-weight-bold">Data:</v-col>
              <v-col cols="8">{{ new Date(request.createdAt).toLocaleDateString('pt-BR') }}</v-col>
            </v-row>
          </v-card>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="closeDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="error"
            text
            @click="confirmDelete"
            :loading="loading"
          >
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: 'DeleteRequestDialog',
    
    props: {
      value: {
        type: Boolean,
        default: false
      },
      request: {
        type: Object,
        default: null
      }
    },
    
    data() {
      return {
        loading: false
      };
    },
    
    computed: {
      dialogModel: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        }
      }
    },
    
    methods: {
      closeDialog() {
        this.dialogModel = false;
        this.$emit('close');
      },
      
      async confirmDelete() {
        if (!this.request) return;
        
        this.loading = true;
        
        try {
          const { success, error } = await this.$store.dispatch('request/deleteRequest', this.request.id);
          
          if (success) {
            this.$emit('deleted');
            this.closeDialog();
            this.$emit('snackbar', {
              color: 'success',
              text: `Requisição ${this.request.code} excluída com sucesso!`
            });
          } else {
            this.$emit('snackbar', {
              color: 'error',
              text: `Erro ao excluir requisição: ${error}`
            });
          }
        } catch (error) {
          console.error('Erro ao excluir requisição:', error);
          this.$emit('snackbar', {
            color: 'error',
            text: 'Ocorreu um erro ao excluir a requisição.'
          });
        } finally {
          this.loading = false;
        }
      }
    }
  };
  </script>